module.exports = __webpack_public_path__ + "img/图层600.15cbddba.png";